export default __webpack_public_path__ + "static/media/pdfIcon.8f32e1b6.svg";